module.exports = __webpack_public_path__ + "static/betterers-duo2x-87e2c920c3884eecec535b9bff683228.png";